function isObject(value) {
    return value !== null && typeof value === 'object';
}

export { isObject };
